import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useEvent, useIsMounted} from '@chekinapp/ui';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

type UseGuestMutation = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
  onSettled?: () => void;
  onMutate?: () => void;
  onDeleted?: (guestId: string) => void;
};
function useDeleteGuest(props: UseGuestMutation = {}) {
  const isMounted = useIsMounted();
  const queryClient = useQueryClient();
  const onSuccess = useEvent(props.onSuccess);
  const onError = useEvent(props.onError);
  const onSettled = useEvent(props.onSettled);
  const onMutate = useEvent(props.onMutate);
  const onDeleted = useEvent(props.onDeleted);
  return useMutation<unknown, Error, string>({
    mutationFn: (guestId: string) => API.guest.delete(guestId),
    onSuccess: (_, guestId) => {
      onSuccess();
      onDeleted(guestId);
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.reservation],
      });
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.summary],
      });
      void queryClient.resetQueries({
        queryKey: [QUERY_CACHE_KEYS.formFields],
      });
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.guestGroup],
      });
    },
    onMutate,
    onError: error => {
      if (!isMounted) return;
      onError(error);
    },
    onSettled,
  });
}

export {useDeleteGuest};
